require('../../modules/es.string.trim-start');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('String', 'trimLeft');



//////////////////
// WEBPACK FOOTER
// ./node_modules/jspdf/node_modules/core-js/es/string/trim-left.js
// module id = r/lV
// module chunks = 3